import React, { FC } from 'react';

type Props = {
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
};

export const Form: FC<Props> = ({ children, onSubmit }) => (
  <form className="modal__form" onSubmit={onSubmit}>
    {children}
  </form>
);

Form.defaultProps = {
  onSubmit: /* istanbul ignore next */ () =>
    // eslint-disable-next-line no-console
    console.log('default: Form.onSubmit'),
};
